import React from 'react';
import { isBrowser } from 'react-device-detect';

const ProductItem = (props) => {
    const {title, parsed_descriptions, price} = props;
    return(
        <div className="product-item-holder">
            <div className={isBrowser ? "product-title" : "product-title-mobile"}>
                <div className="title">{title}</div> <div className="count">برای {price.count} نفر</div>
            </div>
            <div className={isBrowser ? "product-description" : "product-description-mobile"}>
                {
                    parsed_descriptions !== null ? (parsed_descriptions.length > 0 ? parsed_descriptions[0]['description'] : '-') : null
                }
            </div>
        </div>
    )
};

export default ProductItem;